<template>
    <main>
        <b-container fluid="lg">
            <span style="color: #7f7f7f">Σύνολο: {{ totalItems }}</span>
            <b-row class="justify-content-end">
                <b-button variant="success" size="sm"
                          v-on:click="exportChanges">
                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                    Κατέβασμα σε Excel
                </b-button>
            </b-row>
            <b-row class="overflow-auto">
                <b-table class="efedros-table" show-empty striped :items="efpUsers" :fields="fields" :current-page="currentPage"
                         :per-page="0"></b-table>
                <b-pagination size="md" :total-rows="totalItems" @change="pageChange" v-model="currentPage"
                              :per-page="perPage"></b-pagination>
            </b-row>
        </b-container>
    </main>
</template>

<script>
import {HTTP} from "../main.js";

export default {
    data: function () {
        return {
            efpUsers: [],
            fields: [
                {
                    key: 'efSa',
                    label: 'ΣΑ'
                },
                {
                    key: 'firstName',
                    label: 'Όνομα'
                },
                {
                    key: 'lastName',
                    label: 'Επίθετο'
                },
                {
                    key: 'fatherName',
                    label: 'Πατρώνυμο'
                },
                {
                    key: 'motherName',
                    label: 'Μητρώνυμο'
                },
                {
                    key: 'xrwmaEfp',
                    label: 'Είδος ΕΦΠ'
                },
                {
                    key: 'parakolouthousaMee',
                    label: 'Παρακολουθούσα ΕΑ'
                },
                {
                    key: 'sygrotousaMee',
                    label: 'Συγκροτούσα ΕΑ'
                },
                {
                    key: 'fapMee',
                    label: 'ΕΑ τήρησης ΦΑΠ'
                },
                {
                    key: 'monaKwd',
                    label: 'Κωδικός Μονάδας'
                },
                {
                    key: 'date',
                    label: 'Ημερομηνία λήψης'
                },
            ],
            currentPage: 1,
            perPage: 20,
            totalItems: 0
        };
    },

    mounted() {
        this.fetchData()
    },

    methods: {
            pageChange(page) {
                this.currentPage = page
                this.fetchData()
            },
            async fetchData() {
                let size = this.perPage == null ? 10 : this.perPage;
                let page = this.currentPage == null ? 0 : this.currentPage - 1

              let url = '/home'
              if (this.$store.getters.userRole === "ROLE_MANAGER" || this.$store.getters.userRole === "ROLE_SXHMATISMOS" ) {
                  url = "/manager/fetch-efp-users?page="+ page  +"&size="+ size +"";
                } else if (this.$store.getters.userRole === "ROLE_ADMIN" || this.$store.getters.userRole === "ROLE_SUPERADMIN") {
                  url = "/admin/fetch-efp-users?page="+ page  +"&size="+ size +"";
                }

            this.$store.dispatch('loading');

            HTTP.get(url).then(response => {
                if (response.data.responseData.content.length > 0) {
                    this.efpUsers = response.data.responseData.content
                    this.totalItems = response.data.responseData.totalElements
                }
            }).catch((error) => {
                console.error(error);
                this.$store.dispatch('stop_loading');
            }).finally(() => {
                this.$store.dispatch('stop_loading');
            });
        },
        exportChanges() {
            let size = 1000000;
            let page = 0;

            let url = '/home'
            if (this.$store.getters.userRole === "ROLE_MANAGER" || this.$store.getters.userRole === "ROLE_SXHMATISMOS") {
                url = "/manager/download-efp-users?page=" + page + "&size=" + size;
            } else if (this.$store.getters.userRole === "ROLE_ADMIN" || this.$store.getters.userRole === "ROLE_SUPERADMIN") {
                url = "/admin/download-efp-users?page=" + page + "&size=" + size;
            }
            this.$store.dispatch("loading")
            HTTP.get(url, {
                responseType: 'blob'
            }).then(res => {
                let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'efedros_efp.xls';
                link.click();
            }).finally(() => this.$store.dispatch("stop_loading"))
        }
    }
};
</script>
               